import React, { useState, useEffect, useLayoutEffect } from 'react'
import { MAP_SIZES_TO_PROPS } from '../../../../constants'
import { buildSearchTitle, navBarOffSet } from '../searchUtil'
import { useHistory } from 'react-router-dom'
import withSizes from 'react-sizes'
import { auth } from 'components/auth/auth.js'
import MetaTags from '../../../elements/meta/metaTags.js'
import {
  trackDesktopMapOn,
  trackDesktopMapOff,
} from '../../../elements/tracking/searchTracking.js'
import './searchLayout.sass'
import { compose } from 'recompose'
import { BRAND_FILTER_SHORT_NAME } from '../../filters/brand/searchBrandConfig'
import { PRICE_FILTER_SHORT_NAME } from '../../filters/price/priceFilterConfig'
import { SORTBY_FILTER_SHORT_NAME } from '../../filters/sortby/sortByFilterConfig'
import { ENGINE_FILTER_SHORT_NAME } from '../../filters/moreFiltersContainer/engineFilterConfig'
import { SEAT_FILTER_SHORT_NAME } from '../../filters/moreFiltersContainer/seatFilterConfig'
import { STYLE_FILTER_SHORT_NAME } from '../../filters/style/styleFilterConfig'
import { MAX_DISTANCE_FILTER_SHORT_NAME } from '../../filters/moreFiltersContainer/distanceFilterConfig'
import { YEAR_FILTER_SHORT_NAME } from '../../filters/moreFiltersContainer/yearsFilterConfig'
import { LOCATION_SHORT_NAME, LATITUDE_SHORT_NAME, LONGITUDE_SHORT_NAME } from '../../filters/location/locationFiltersConfig'
import { PAGE_FILTER_SHORT_NAME } from '../../filters/pagination/paginationFilterConfig'
import { NEWLY_LISTED_FILTER_SHORT_NAME } from '../../filters/moreFiltersContainer/newlyListedConfig'
import { TWENTY_POINT_INSPECTED_FILTER_SHORT_NAME } from '../../filters/moreFiltersContainer/twentyPointInspected'
import {
  START_DATE_SHORT_NAME,
  END_DATE_SHORT_NAME,
} from '../../filters/dates/datesFilterConfig'
import { INSTANT_BOOKING_SHORT_NAME } from '../../filters/instantBooking/instantBookingConfig'
import { IS_BIKE_FOR_SALE_FILTER_SHORT_NAME } from '../../filters/moreFiltersContainer/isBikeForSaleFilterConfig'
import { PAGE_COUNT_FILTER_SHORT_NAME } from 'components/search/filters/pagination/pageCountFilterConfig'

import { setSearchPageState } from '../../calls/setSearchPageState'
import { buildTheQueryString, removeDefaults } from 'components/search/filters/filterUtil'

import DatesFilter from '../../filters/dates/searchDateFilter.js'
import SortByFilter from '../../filters/sortby/sortByFilter.js'
import StyleFilter from '../../filters/style/searchStyleFilter.js'
import BrandFilter from '../../filters/brand/searchBrandFilter.js'
import MoreFilter from '../../filters/moreFiltersContainer/searchMoreFilterContainer.js'
import InstantBookingConfig from '../../filters/instantBooking/instantBookingConfig.js'
import SearchResultsLayoutWrap from '../results/searchResultsWrap'
import MapSwitch from '../../filters/mapSwitch/searchMapSwitch.js'
import MobileSearchFilters from '../../filters/mobileFilters/mobileSearchFilters.js'
import { Columns } from 'components/elements'
import Cookies from 'js-cookie'

const scrollToTop = (isMobile) => {
  const element = isMobile ? 'html' : 'body'

  const scrollOptions = { top: 0, left: 0, behavior: 'auto' }
  if (navigator.userAgent.search('Firefox') === -1) {
    scrollOptions.behavior = 'smooth'
  }
  document.querySelector(element).scrollTo(scrollOptions)
}

const SearchMainLayout = (props) => {
  const history = useHistory()
  const [filterValues, setFilterValues] = useState(
    setSearchPageState(props.initialValues)
  )
  const [mapVisible, setMapVisible] = useState(props.isMobile ? false : true)
  const [allAdvertisements, setAllAdvertisements] = useState(null)
  const [userCreditsCents, setUserCreditsCents] = useState(Cookies.get("userAccountCreditsCents"))
  const [userFreeDays, setUserFreeDays] = useState(Cookies.get("userFreeDays"))
  const [userIsRpmComotoMember, setUserIsRpmComotoMember] = useState(Cookies.get("userIsRpmComotoMember"))
  const [ridesUntilFreeDay, setRidesUntilFreeDay] = useState(Cookies.get("userRidesUntilFreeDay"))
  const isAuth = props.isAuth
  const isMobile = props.isMobile
  const searchData = props.searchData
  const searchLoading = props.searchLoading
  const initialLoading = props.initialLoading
  const hasSearchData = props.hasSearchData
  const searchError = props.searchError
  const allCoordinates = props.allCoordinates
  const advertisement = props.advertisement
  const mapboxSearchLoading = props.mapboxSearchLoading
  const hasMapboxSearchData = props.hasMapboxSearchData
  const mapboxSearchError = props.mapboxSearchError
  const groupedMarkers = props.groupedMarkers
  const runSearch = props.runSearch
  const disableMetaTags = props.disableMetaTags
  const myRef = React.createRef()
  const isLoggedIn = auth.isAuthenticated()
  const isTripTaken = Number(auth.userRideTakenCount()) > 0

  useEffect(() => {
    if (!isLoggedIn || !isTripTaken) {
      document.body.classList.add(`klaviyo-${isMobile ? 'mobile' : 'desktop'}-banner-added`)
    }
    document.body.classList.add('search-page')
    document.documentElement.classList.add('search-page')
    scrollToTop(props.isMobile)
  }, [])

  useEffect(() => {
    setFilterValues(setSearchPageState(props.initialValues))
    scrollToTop(props.isMobile)
  }, [props.initialValues.location])

  useEffect(() => {
    if (props.isMobile) {
      setMapVisible(false)
      document.body.classList.remove('mobile-filters-open')
    } else {
      setMapVisible(true)
      document.body.classList.remove('mobile-filters-open')
    }
    scrollToTop(props.isMobile)
  }, [props.isMobile])

  useEffect(() => {
    if (isLoggedIn && isTripTaken) {
      document.body.classList.remove('klaviyo-banner-added')
    }
  }, [isLoggedIn, isTripTaken])

  useLayoutEffect(() => {
    return () => {
      document.body.classList.remove('search-page')
      document.body.classList.remove('klaviyo-banner-added')
    }
  }, [])

  useEffect(() => {
    async function getAdvertisements() {
      await auth.fetchAdvertisements()
      let tempAllAdvertisements = sessionStorage.getItem("allAdvertisements")
      setAllAdvertisements(tempAllAdvertisements)
    }

    getAdvertisements()
  }, [isAuth])


  const handleUpdateFilterValue = () => {
    if (filterValues.hasOwnProperty(PAGE_FILTER_SHORT_NAME)) {
      delete filterValues.page
      setFilterValues(filterValues)
    }
    if (filterValues.hasOwnProperty(PAGE_COUNT_FILTER_SHORT_NAME)) {
      delete filterValues.page_count
      setFilterValues(filterValues)
    }
  }
  const updateFilterValue = async (filterNameOrObject, filterValue) => {
    scrollToTop(props.isMobile)

    let filterValuesTemp = JSON.parse(JSON.stringify(filterValues))

    if (filterNameOrObject instanceof Object) {
      let dupCount = 0
      let objectCount = 0
      for (var key in filterNameOrObject) {
        if (filterValuesTemp[key] === filterNameOrObject[key]) {
          dupCount++
        }
        filterValuesTemp[key] = filterNameOrObject[key]
        objectCount++
      }

      if (dupCount === objectCount) {
        return false
      }
    }

    if (!(filterNameOrObject instanceof Object)) {
      if (filterValuesTemp[filterNameOrObject] === filterValue) {
        return false
      }
      filterValuesTemp[filterNameOrObject] = filterValue
    }

    let newQueryString = buildTheQueryString(removeDefaults(filterValuesTemp))
    // when new query string is pushed, componentDidUpdate() inside /calls/runSearch.js will be triggered and it will set the params. 
    history.push('?' + newQueryString)
  }

  const updatePageFilterValue = (value) => {
    if (filterValues.page === value) {
      return false
    }

    let filterValuesTemp = filterValues
    filterValuesTemp[PAGE_FILTER_SHORT_NAME] = value
    filterValuesTemp[PAGE_COUNT_FILTER_SHORT_NAME] = 10
    setFilterValues(filterValuesTemp)
    props.runSearch(filterValuesTemp, 'update filter', false)
    //false bool value indicates filters applied or not
  }

  const updateDates = (startDate, endDate) => {
    if (
      filterValues.startDate === startDate &&
      filterValues.endDate === endDate
    ) {
      return false
    }

    let filterValuesTemp = filterValues
    filterValuesTemp[START_DATE_SHORT_NAME] = startDate
    filterValuesTemp[END_DATE_SHORT_NAME] = endDate
    setFilterValues(filterValuesTemp)
    let currentState = filterValuesTemp
    currentState[START_DATE_SHORT_NAME] = startDate
    currentState[END_DATE_SHORT_NAME] = endDate
    currentState[PAGE_FILTER_SHORT_NAME] = 1
    props.runSearch(currentState, 'update dates', true)
  }

  const onFilterOpen = () => {
    let dimmerDiv = document.getElementById('dimmer-div')
    if (dimmerDiv) {
      dimmerDiv.className = 'dimmer'
    }
  }

  const onFilterClose = () => {
    let dimmerDiv = document.getElementById('dimmer-div')
    if (dimmerDiv) {
      dimmerDiv.className =  ''
    }
  }

  const applyMobileFilters = (newFilters) => {
    scrollToTop(props.isMobile)
    props.runMapBoxSearch(newFilters, 'mobile filters mapbox search')
    newFilters[PAGE_COUNT_FILTER_SHORT_NAME] =10
    setFilterValues(newFilters)
    props.runSearch(newFilters, 'apply mobile filters', true)
  }

  const toggleMap = (value) => {
    setMapVisible(value)
    if (value) {
      trackDesktopMapOn()
    }
    if (!value) {
      trackDesktopMapOff()
    }
  }

  return (
    <React.Fragment>
      {!searchLoading && hasSearchData && !disableMetaTags && (
        <MetaTags
          title={
            buildSearchTitle(
              searchData.results_meta.total_results,
              filterValues[LOCATION_SHORT_NAME],
              true
            ) + ' | Twisted Road'
          }
          desctiption={buildSearchTitle(
            searchData.results_meta.total_results,
            filterValues[LOCATION_SHORT_NAME],
            true
          )}
          url={'https://www.twistedroad.com/search'}
        />
      )}
      {isMobile && (
        <MobileSearchFilters
          isMobile={isMobile}
          mapVisible={mapVisible}
          filterValues={filterValues}
          onApply={applyMobileFilters}
          onToggleMap={toggleMap}
          showDateWarning={!filterValues.startDate && !filterValues.endDate}
        />
      )}

      <div className="is-relative" ref={myRef}>
        <div id="dimmer-div"></div>
        {!isMobile && (
          <Columns
            className="search-filters-bar is-mobile buttons"
            style={{
              top: navBarOffSet(isMobile).filterStart,
              left: 0,
              right: 0,
              position: 'fixed',
            }}
            id="search-filters-bar"
          >
            <Columns.Column size={10}>
              <DatesFilter
                onOpen={onFilterOpen}
                onClose={onFilterClose}
                onApply={updateDates}
                startDate={filterValues[START_DATE_SHORT_NAME]}
                endDate={filterValues[END_DATE_SHORT_NAME]}
              />
              <SortByFilter
                onOpen={onFilterOpen}
                onClose={onFilterClose}
                onApply={(value) => {
                  handleUpdateFilterValue()
                  updateFilterValue(SORTBY_FILTER_SHORT_NAME, value)
                }}
                currentSortBy={filterValues[SORTBY_FILTER_SHORT_NAME]}
              />
              <StyleFilter
                onOpen={onFilterOpen}
                onClose={onFilterClose}
                onApply={(value) => {
                  handleUpdateFilterValue()
                  updateFilterValue(STYLE_FILTER_SHORT_NAME, value)
                }}
                currentStyles={filterValues[STYLE_FILTER_SHORT_NAME]}
              />
              <BrandFilter
                onOpen={onFilterOpen}
                onClose={onFilterClose}
                onApply={(value) => {
                  handleUpdateFilterValue()
                  updateFilterValue(BRAND_FILTER_SHORT_NAME, value)
                }}
                currentBrands={filterValues[BRAND_FILTER_SHORT_NAME]}
              />
              <InstantBookingConfig
                location={props.location}
                onApply={(value) => {
                  handleUpdateFilterValue()
                  updateFilterValue(INSTANT_BOOKING_SHORT_NAME, value)
                }}
                currentConfig={filterValues}
              />
              <MoreFilter
                onOpen={onFilterOpen}
                onClose={onFilterClose}
                onApply={(value) => {
                  handleUpdateFilterValue()
                  updateFilterValue(value)
                }}
                distance={filterValues[MAX_DISTANCE_FILTER_SHORT_NAME]}
                currentPriceRange={filterValues[PRICE_FILTER_SHORT_NAME]}
                currentYears={filterValues[YEAR_FILTER_SHORT_NAME]}
                currentEngines={filterValues[ENGINE_FILTER_SHORT_NAME]}
                currentSeatRange={filterValues[SEAT_FILTER_SHORT_NAME]}
                newlyListed={filterValues[NEWLY_LISTED_FILTER_SHORT_NAME]}
                twentyPointInspected={filterValues[TWENTY_POINT_INSPECTED_FILTER_SHORT_NAME]}
                isBikeForSale={filterValues[IS_BIKE_FOR_SALE_FILTER_SHORT_NAME]}
              />
            </Columns.Column>
            <Columns.Column size={2} className="has-text-right">
              <MapSwitch
                onChange={(value) => toggleMap(value)}
                initialSetting={mapVisible}
                disabled={searchLoading || searchData?.results?.length === 0}
              />
            </Columns.Column>
          </Columns>
        )}
        <SearchResultsLayoutWrap
          offset={navBarOffSet(isMobile).layoutStart}
          filterValues={filterValues}
          isAuth={isAuth}
          mapVisible={mapVisible}
          searchData={searchData.results}
          hasSearchData={hasSearchData}
          searchMeta={searchData.results_meta}
          searchError={searchError}
          isMobile={isMobile}
          onScroll={(value) => {
            updatePageFilterValue(value)
          }}
          onMapMove={(filterObject) => {
            handleUpdateFilterValue()
            updateFilterValue(filterObject)
          }}
          runSearch={runSearch}
          searchLoading={searchLoading}
          initialLoading={initialLoading}
          startDate={filterValues[START_DATE_SHORT_NAME]}
          endDate={filterValues[END_DATE_SHORT_NAME]}
          mapboxSearchError={mapboxSearchError}
          mapboxSearchLoading={mapboxSearchLoading}
          hasMapboxSearchData={hasMapboxSearchData}
          groupedMarkers={groupedMarkers}
          allCoordinates={allCoordinates}
          advertisement={advertisement}
          allAdvertisements={allAdvertisements}
          userCreditsCents={parseInt(userCreditsCents)}
          userFreeDays={parseInt(userFreeDays)}
          userIsRpmComotoMember={userIsRpmComotoMember == "true"}
          ridesUntilFreeDay={parseInt(ridesUntilFreeDay)}
        />
      </div>
    </React.Fragment>
  )
}

export default compose(withSizes(MAP_SIZES_TO_PROPS))(SearchMainLayout)

SearchMainLayout.defaultProps = {
  initialValues: {},
  searchLoading: true,
  runSearch: function () { },
  searchError: false,
  hasSearchData: false,
  searchData: [],
}
